<template>

	<div>
		<b-container fluid class="p-0">
			<b-row>
				<b-col>
					<p>{{label}}</p>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="3"></b-col>
				<b-col cols="9" class="option-flex">
					<div class="flex-option-head" v-for="(column, colIndex) in columns" :key="colIndex" style="text-align:center">
						<span class="label">
							{{column}}
						</span>
					</div>
				</b-col>
			</b-row>
			
			<b-row
			class="option-row mb-1 p-1"
			v-for="(row, rowIndex) in rows" :key="rowIndex"
			>
				<b-col cols="3">
					<p class="row-label">
						{{row}}
					</p>
				</b-col>

				<b-col class="option-flex">
					<div class="flex-option" v-for="(column, colIndex) in columns" :key="colIndex">
						<label class="stretch-label">
							<div class="highlight-box"></div>
							<b-form-radio
							size="lg"
							button-variant="primary"
							class="option-button" v-model="response[rowIndex]" :value="colIndex"/>
						</label>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>

</template>

<script>
	export default {
		props:{
			"data":Object
		},
		computed:{
			label(){
				return this.data.settings.label;
			},
			rows(){
				return this.data.settings.rows;
			},
			columns(){
				return this.data.settings.columns;
			}
		},
		data(){
			return {
				response: []
			}
		},
		created(){
			this.data.settings.rows.forEach(row => {
				this.response.push(null);
			})
		}
	}
</script>

<style scoped lang="scss">


	@import "../../sass/colors.scss";

	.option-flex{
		display:flex;
		justify-content: space-evenly;
		width:100%;
	}

	.flex-option{
		display:flex;
		flex-grow: 1 1 auto;
		width:100%;
	}
	
	.option-row:nth-child(odd){
		background:rgb(214, 215, 217);
	}

	.option-row{
		position: relative;
	}



	.stretch-label{
		width:100%;
		height:100%;
		display:flex;
		position:relative;
		cursor:pointer;
	}

	.stretch-label:hover .highlight-box{
		opacity:1;
	}

	.option-button{
		margin:auto;
	}


	.highlight-box{
		width:100%;
		height:100%;
		position: absolute;
		top:0;
		left:0;
		z-index:2;
		opacity:0;
		border:1px solid rgba(0, 0, 0, 0.1);
		border-radius: 1em;
	}

	.row-label{
		width:100%;
		height:100%;
		padding:0em;
	}

	.flex-option-head{
		display:flex;
		flex-grow: 1 1 auto;
		width:100%;
		font-weight: bold;

		.label{
			margin:auto;
		}
	}


</style>